import BigNumber from "bignumber.js";

/**
 * 숫자로 읽히는 형태만 통과시키는 정규식. `new BigNumber("Free")` 는 NaN 을
 * 돌려주지 않고 **던진다** — 견적 행 값은 호출부(dApp)가 만드는 표시용 문자열이라
 * `"Free"`, `"-"`, `"—"` 같은 것이 섞여 오고, 그대로 넘기면 화면이 죽는다.
 */
const NUMERIC = /^[+-]?(\d+\.?\d*|\.\d+)(e[+-]?\d+)?$/i;

/**
 * 표시용 문자열에서 숫자를 뽑는다. 숫자가 아니면 `null` — 던지지 않는다.
 * 콤마·퍼센트·공백은 제거한다(`"1,234.5%"` → 1234.5).
 */
export function parseNumeric(value?: unknown): BigNumber | null {
  if (value === null || value === undefined) return null;
  if (value instanceof BigNumber) return value.isFinite() ? value : null;
  if (typeof value === "number") {
    return Number.isFinite(value) ? new BigNumber(value) : null;
  }
  const cleaned = String(value).replace(/[,%\s]/g, "");
  if (!NUMERIC.test(cleaned)) return null;
  const parsed = new BigNumber(cleaned);
  return parsed.isFinite() ? parsed : null;
}
